import BalanceCard from "./BalanceCard";
import BalanceCardSkeleton from "./BalanceCardSkeleton";

export default {
	BalanceCard,
	BalanceCardSkeleton
};
